import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ClassForScreenDirective } from '../../../lib/directives/class-for-screen.directive';
import { PortaleLayoutHeaderComponent } from '../../layout/portale-layout-header/portale-layout-header.component';
import { ScaricaAppComponent } from '../components/scarica-app.component';
import { PortaleLayoutFooterComponent } from '../../layout/portale-layout-footer/portale-layout-footer.component';

@Component({
    selector: 'app-prezzo',
    templateUrl: './prezzo.component.html',
    styleUrls: ['./prezzo.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ClassForScreenDirective, PortaleLayoutHeaderComponent, ScaricaAppComponent, PortaleLayoutFooterComponent]
})
export class PrezzoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
